// Put flow-2 deliveries back in seq order before they reach the demuxer.
// Up to rift 8269cbd, rift-wt delivered frames as their chunks completed,
// which is not always seq order (rift#28). From 26ba8da its receiver delivers
// in flow order and waits for a missing payload, so this is a guard rather
// than a fix; it stays because the TS demuxer is a byte stream, and an
// out-of-order frame would splice one PES into another.
//
// Small window, same default as the gateway's ISO reorder (contracts §5):
// hold up to `window` frames waiting for a gap to fill, then give up on the
// missing seq and release what we have. A frame older than what was already
// released is dropped. The conversational loop would rather skip a frame
// than stall on it.
export class SeqReorder {
    window;
    next = null;
    held = new Map();
    stats = { late: 0, skipped: 0 };
    constructor(window = 8) {
        this.window = window;
    }
    /** Accept one delivery; returns the frames now releasable, in order. */
    push(seq, item) {
        if (this.next === null)
            this.next = seq;
        if (seq < this.next) {
            this.stats.late++;
            return [];
        }
        this.held.set(seq, item);
        const out = [];
        this.drain(out);
        while (this.held.size > this.window) {
            // Gap never filled: jump to the oldest held seq.
            this.stats.skipped += Math.min(...this.held.keys()) - this.next;
            this.next = Math.min(...this.held.keys());
            this.drain(out);
        }
        return out;
    }
    /** A new session restarts seq numbering. */
    reset() {
        this.next = null;
        this.held.clear();
    }
    drain(out) {
        while (this.next !== null && this.held.has(this.next)) {
            out.push(this.held.get(this.next));
            this.held.delete(this.next);
            this.next++;
        }
    }
}
//# sourceMappingURL=reorder.js.map